var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "var(--background-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90756 5.44821C6.69756 5.08942 6.32126 4.875 5.90555 4.875C5.48984 4.875 5.11359 5.08942 4.90359 5.44821L2.65453 9.30744C2.61516 9.37307 2.61516 9.45619 2.65453 9.52624C2.69391 9.59186 2.76391 9.63561 2.84266 9.63561H5.68238L7.51572 6.48959L6.90756 5.44821ZM11.3444 9.30749L9.86107 6.76093C9.65107 6.40214 9.27478 6.18772 8.85907 6.18772C8.46527 6.18772 8.10648 6.38026 7.89206 6.70843L6.18559 9.6357H11.1562C11.235 9.6357 11.305 9.59195 11.3444 9.52632C11.3838 9.45624 11.3838 9.37311 11.3444 9.30749Z",
    fill: "var(--mountain-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 10.5108H8.53081C8.41006 10.5108 8.31201 10.4128 8.31201 10.292C8.31201 10.1713 8.41006 10.0732 8.53081 10.0732H11.1562C11.2769 10.0732 11.3749 10.1713 11.3749 10.292C11.3749 10.4128 11.2769 10.5108 11.1562 10.5108Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHills);
export default __webpack_public_path__ + "static/media/hills.f5e6f6e6578b4f6f627d269eb821a5e1.svg";
export { ForwardRef as ReactComponent };